module.exports = __webpack_public_path__ + "static/media/logo-poupa-energia.ed1acefe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RatingHeader/logo-poupa-energia.png
// module id = 1677
// module chunks = 0